'use client';

import React from 'react';
import { useAuth } from '@/components/Auth';
import { FullPageLoader } from '@/components';
import { COMMON_TEXT, STATUS_MESSAGES } from '@/constants';

/**
 * LandingPage serves as the initial entry point for the application. It relies on the
 * AuthProvider to manage authentication state and redirects.
 *
 * When a user lands on this page, the AuthProvider will determine if they are authenticated.
 * If not, it will redirect them to the login page. If they are authenticated, it will
 * redirect them to the dashboard. This component displays a loading state while the
 * AuthProvider processes authentication and handles any necessary redirects.
 */
export default function LandingPage() {
  const { isLoading } = useAuth();

  // Show loading state while AuthProvider handles authentication and redirects
  return (
    <FullPageLoader
      heading={COMMON_TEXT.SALES_TRAINING_PLATFORM}
      message={isLoading ? STATUS_MESSAGES.LOADING : STATUS_MESSAGES.REDIRECT_DASHBOARD}
    />
  );
}
